import MainLayout from "@/components/layout/admin/MainLayout.vue";
// import Pagination from "laravel-vue-pagination";
import axios from "axios";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';

export default {
    name: "AdminApplicantList",
    components: {
        MainLayout,
        // Pagination,
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            applicants: {},
            isShowApplicants: true,
            isAddApplicant: false,
            isUpdateApplicant: false,
            keyword: "",
            page_status: false,
        };
    },

    methods: {
        getApplicant(page = 1) {
            axios.get("/admin/applicant/list?page=" + page)
                .then(response => {
                    this.applicants = response.data;
                })
                .catch(error => {
                    console.log("User List API Error", error);
                });
        },

        cancelCreate() {
            this.$router.push({
                name: "adminApplicantList"
            });
            this.isShowApplicants = true;
            this.isAddApplicant = false;
        },

        create(applicant) {
            this.isAddApplicant = false;
            this.applicants = applicant || this.applicants;
            this.applicantData = "";
            this.$router.push({
                name: "adminApplicantList"
            });
            this.getApplicant();
        },

        showUpdate(applicant) {
            this.isUpdateApplicant = true;
            this.applicantData = applicant;
            this.$router.push({
                path: "/admin/applicant/update/" + applicant.id
            });
        },

        cancelUpdate() {
            this.isUpdateApplicant = false;
            this.$router.push({
                name: "adminApplicantList"
            });
        },

        update(applicants) {
            this.isUpdateApplicant = false;
            this.applicants = applicants || this.applicants;
            this.applicantData = "";
            this.$router.push({
                name: "applicantList"
            });
            this.getApplicant();
        },

        confirmDelete(id) {
            if (window.confirm("Are you sure?")) {
                this.deleteApplicant(id);
            } else {
                console.log("no");
            }
        },

        deleteApplicant(id) {
            axios.delete("/admin/applicant/delete/" + id)
                .then(response => {
                    this.applicants = response.data;
                    this.getApplicant();
                })
                .catch(error => {
                    console.log("Applicant Delete Error->", error.response.data);
                });
        },

        searchApplicant(page = 1) {
            var request = {
                params: {
                    keyword: this.keyword
                }
            }
            axios.get("admin/applicant/search/result?page="+page, request)
                .then(response => {
                    this.page_status = true;
                    this.applicants = response.data;
                })
                .catch(error => {
                    console.log("Applicant Search API Error", error.response.data);
                });
        }
    },

    mounted() {
        this.getApplicant();
    }
};